export default "__VITE_ASSET__303b1ae8__"